/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Breadcrumb from '../app/Breadcrumb.react';
import DocumentTitle from 'react-document-title';
import { getUISettings } from '../app/UISettings.react';

export default class extends React.Component {
    static propTypes = {
        breadcrumbParams: PropTypes.array,
        children: PropTypes.any,
		className: PropTypes.any,
		id: PropTypes.string,
        title: PropTypes.string,
		titleAsHeader: PropTypes.bool
    };

	static defaultProps = {
		breadcrumbParams: []
	};

    constructor() {
        super();
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        const uiSettings = getUISettings();

        return (
            <DocumentTitle id={this.props.id} title={this.props.title}>
                <div>
					{this.props.breadcrumbParams && !uiSettings.hideNaviPath ? <Breadcrumb params={this.props.breadcrumbParams} /> : null }

                    <div className={"appPanel " + (this.props.className ? this.props.className : "")}>
						{this.props.titleAsHeader ? <h2>{this.props.title}</h2> : null}
                        {this.props.children}
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}
